import clsx from 'clsx';
import type { ReactNode } from 'react';

export interface SchedulerProps {
    /** Left rail content (e.g. searchable item list). */
    sidebar: ReactNode;
    /** Main pane — typically a `Calendar`. */
    children: ReactNode;
    className?: string;
    sidebarClassName?: string;
    mainClassName?: string;
    /** Accessible name for the sidebar rail. */
    sidebarLabel?: string;
}

/**
 * Two-pane scheduler shell: sidebar + main (calendar).
 * Pair with `Calendar` and page-specific drag/drop wiring.
 */
export function Scheduler({
    sidebar,
    children,
    className,
    sidebarClassName,
    mainClassName,
    sidebarLabel = 'Topic library',
}: SchedulerProps) {
    return (
        <div className={clsx('scheduler', className)}>
            <aside
                className={clsx('scheduler-sidebar', sidebarClassName)}
                aria-label={sidebarLabel}
            >
                {sidebar}
            </aside>
            <div className={clsx('scheduler-main', mainClassName)}>{children}</div>
        </div>
    );
}

export default Scheduler;
